"use client";

import { cn, Typography } from "@kyan/ui";
import Image from "next/image";
import Link from "next/link";

import { appVersion } from "#/config/appVersion";
import { routes } from "#/config/routes";
import { useTheme } from "#/hooks/useTheme";

interface LogoProps {
  className?: string;
  showVersion?: boolean;
}

export const Logo: React.FC<LogoProps> = ({
  className,
  showVersion = true,
}) => {
  const { theme } = useTheme();

  return (
    <div className="relative">
      <Link href={routes.options()}>
        <Image
          priority
          alt="Kyan"
          width={83}
          height={37.5}
          src={`/images/components/logo-${theme}.png`}
          className={cn(
            "h-[37.5px] w-8 min-w-8 object-cover object-left xl:w-20.75",
            className,
          )}
        />
      </Link>
      {showVersion && (
        <Typography className="xl:text-xxs absolute -bottom-3 text-[9px] whitespace-nowrap xl:-right-6">
          v{appVersion}
        </Typography>
      )}
    </div>
  );
};
